var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 24,
    height: 16,
    viewBox: "0 0 50 37",
    style: {
      enableBackground: "new 0 0 50 37"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0872B9;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FBED1F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 27,
    className: "st0",
    width: 49,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.8,
    className: "st0",
    width: 49,
    height: 9.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.8,
    className: "st0",
    width: 49,
    height: 15.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.6,4h-4.1l0.3,0.5h4.1l1.4,0.9c0,0,0.3,0.3,0.1,0.5l-1.6,1.2H39l-0.6-0.8v2.2h-9.7V4.2h7.1v2.2h-4.1v0.8 h4.8h0.2V4.3h2.7l1.6,1.6h4.6V5.1H41l-2.2-2.2h7.1L46.6,4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 7.7,
    className: "st1",
    width: 1,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.1,
    y: 7.7,
    className: "st1",
    width: 1,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    y: 3.4,
    className: "st1",
    width: 1.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 3.4,
    className: "st1",
    width: 1.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 3.4,
    className: "st1",
    width: 1.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 5.5,
    className: "st1",
    width: 3.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "19,5 21.5,5 21.5,7.9 2.9,7.9 1.5,6.1 3.9,2.9 5.8,2.9 4.4,6.1 16.7,6.1 16.7,5.1 18.4,5.1  18.4,6.1 19,6.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.4,34.4H9.8v-2.7c0-0.6,0-0.9-0.1-1.1c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.4,0.3-0.4,0.5C7.7,31,7.6,31.4,7.6,32v2.4H6.1v-5.3h1.4v0.8C8,29.3,8.7,29,9.4,29 c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.6,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.1,0.5,0.1,0.9V34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.8,32.7l1.5,0.2c-0.2,0.5-0.5,0.9-0.9,1.2c-0.4,0.3-1,0.4-1.6,0.4c-1,0-1.8-0.3-2.2-0.9 c-0.4-0.5-0.6-1.1-0.6-1.8c0-0.9,0.3-1.6,0.8-2.1c0.5-0.5,1.1-0.7,1.9-0.7c0.9,0,1.5,0.3,2,0.8c0.5,0.5,0.7,1.3,0.7,2.4h-3.8 c0,0.4,0.1,0.7,0.4,1c0.2,0.2,0.5,0.3,0.9,0.3c0.2,0,0.4-0.1,0.6-0.2C25.6,33.2,25.7,33,25.8,32.7z M25.9,31.3 c0-0.4-0.1-0.7-0.3-0.9c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.9H25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,29.1v1.1h-1v2.1c0,0.4,0,0.7,0,0.8c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.6-0.1 l0.1,1.1c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.2-0.1-0.5-0.1-1v-2.3h-0.7v-1.1h0.7v-1.1l1.5-0.8v1.9H43.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 12,
    className: "st2",
    width: 11.6,
    height: 12.4
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "18.3,17.5 26.9,12.1 42.2,12.1 33.8,17.5 42.9,24.2 26.5,24.2 18.5,18  "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnetIcon);
export default __webpack_public_path__ + "static/media/knet-icon.d0a6734e063c54aacd49f5e8eb0b1c78.svg";
export { ForwardRef as ReactComponent };